import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { formValueSelector, reduxForm } from "redux-form";

import Loader from "../Common/Loader/Loader";
import PrefferedProviderDetails from "./PrefferedProviderDetails/PrefferedProviderDetails";
import noServiceProviderIcon from '../../../public/dashboard/noServiceProviderIcon.svg';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";

import messages from "../../locale/messages";

import { closeHeaderModal, openHeaderModal } from "../../actions/siteadmin/modalActions";
import { getNearestPreferredPartner } from "../../actions/siteadmin/ManualBooking/getNearestPreferredPartner";
import { createBookingAction } from "../../actions/booking/createBookingAction";

import bt from '../../components/commonStyle.css';

function PreferredProviderForm({ formData }) {

    const preferredProviders = useSelector(state => state.booking.preferredProviders)
    const preferredProviderLoading = useSelector(state => state.booking.preferredProviderLoading)
    const selectedPartnerId = useSelector(state => state.form?.PreferredProviderForm?.values?.preferredPartnerId);
    const promoId = useSelector(state => formValueSelector('PromoCodeForm')(state, 'promoId'))
    const isPromoIdRemove = useSelector(state => formValueSelector('PromoCodeForm')(state, 'isPromoIdRemove'))
    const paymentMethodId = useSelector(state => formValueSelector('PaymentMethod')(state, 'paymentMethodId'))
    const description = useSelector(state => formValueSelector('OrderDetails')(state, 'description'))

    const dispatch = useDispatch();
    const { formatMessage } = useIntl();

    const handleClick = () => {
        dispatch(closeHeaderModal('preferredProviderForm'))
        dispatch(openHeaderModal('providerSelectionForm'))
    }

    useEffect(() => {
        const handleProviderRefetch = async () => {
            const bookingData = formData?.bookingData;
            const ordersData = bookingData?.orderItemsList
            const orderItem = bookingData?.orderItemsList?.[0];
            const dropOffLat = orderItem?.dropLat;
            const dropOffLng = orderItem?.dropLng;

            let variables = {
                lat: dropOffLat,
                lng: dropOffLng,
                subCategoryId: ordersData?.map((order) => parseInt(order?.subCategoryId))
            };
            await dispatch(getNearestPreferredPartner(variables));
        }
        handleProviderRefetch()
    }, [])

    const handleConfirmBooking = async () => {
        const bookingData = formData?.bookingData;
        const orderItem = bookingData?.orderItemsList?.[0];

        const orderId = bookingData?.id;
        const requestCurrency = bookingData?.currency;
        const reviewDescription = bookingData?.orderDetails?.description?.trim() ? description : null;

        const dropOffLocation = orderItem?.dropLocation;
        const dropOffLat = orderItem?.dropLat;
        const dropOffLng = orderItem?.dropLng;

        const validPromoId = !isPromoIdRemove
            ? promoId ?? bookingData?.promoId
            : null;

        const preferredPartnerId = selectedPartnerId

        dispatch(closeHeaderModal('preferredProviderForm'))
        dispatch(openHeaderModal('nearestProviderForm', null, true))

        await dispatch(createBookingAction({ orderId, requestCurrency, reviewDescription, dropOffLocation, dropOffLat, dropOffLng, promoId: validPromoId, paymentType: Number(paymentMethodId), preferredPartnerId }))

    }

    return (
        <>
            {preferredProviderLoading && <div className={bt.modalLoader}>
                <Loader type="circle" show={preferredProviderLoading} />
            </div>}
            {
                !preferredProviderLoading && preferredProviders?.length > 0 && (<div>
                    <div className="preferredProviderCardWrapper">
                        {preferredProviders.map((provider, index) => {
                            return (
                                <PrefferedProviderDetails providerData={provider} key={index} />
                            );
                        })}
                    </div>
                    <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                        <Button onClick={() => handleClick()} className={bt.btnSecondary} ><FormattedMessage {...messages.goBackText} /> </Button>
                        <div>
                            <Loader
                                type='button'
                                buttonType='submit'
                                label={formatMessage(messages.confirm)}
                                disabled={!selectedPartnerId}
                                handleClick={() => handleConfirmBooking()}
                                className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                            />
                        </div>
                    </div>

                </div>)
            }
            {
                !preferredProviderLoading && preferredProviders?.length === 0 &&
                <div>
                    <div className={bt.nearestNoServiceImgContainer} >
                        <img src={noServiceProviderIcon} alt="No Service Provider" />
                    </div>
                    <div className={cx(bt.fontWeight700, bt.commonSize20, bt.primaryColor, bt.textAlignCenter)}> <FormattedMessage {...messages.noProviderAvailable} /></div>
                    <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                        <Button onClick={() => handleClick()} className={cx(bt.btnSecondary, bt.cursorPointer)}><FormattedMessage {...messages.goBackText} /> </Button>
                    </div>
                </div>

            }
        </>
    )

}

PreferredProviderForm = reduxForm({
    form: 'PreferredProviderForm',
})(PreferredProviderForm);

export default withStyles(bt)(PreferredProviderForm)
